import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

// Função para truncar o texto com base no limite de caracteres
const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
};

const Home = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'messages'));
        const fetchedMessages = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setMessages(fetchedMessages);
      } catch (error) {
        console.error('Erro ao buscar mensagens: ', error);
        alert('Erro ao buscar mensagens');
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  return (
    <div className="container mt-4">
      <h1>Mensagens</h1>
      {loading ? (
        <p>Carregando...</p>
      ) : (
        <div className="row">
          {messages.map((message) => (
            <div key={message.id} className="col-md-4 mb-3">
              <div
                className="card"
                style={{
                  backgroundColor: message.bgColor,
                  color: message.textColor,
                  borderRadius: '10px',
                }}
              >
                <div className="card-body">
                  <h5 className="card-title">
                    {truncateText(message.name, 20)} {/* Limitar nome a 20 caracteres */}
                  </h5>
                  <p className="card-text">
                    {truncateText(message.message, 100)} {/* Limitar mensagem a 100 caracteres */}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Home;
